import { ApiBaseUrl } from "../config";
import { EstimateAPIModel, ResponseModel } from "../models/apiModels";

export async function createEstimate(estimateApi: EstimateAPIModel) {
  const response = await fetch(`${ApiBaseUrl}/estimate`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(estimateApi),
  });

  if (!response.ok) {
    throw new Error("createEstimate Failed");
  }

  const responseJson: ResponseModel<EstimateAPIModel> = await response.json();
  return responseJson.result;
}